const success = {
  path: 'success',
  component: resolve => require(['../../../../../../../../pages/admin/merchant/signing/yftWeChat/found/success'], resolve)
}

export default success
